// extracted by mini-css-extract-plugin
export default {"container":"eLX1","name":"JKJk","image":"tgAR","info":"Nb8D","info-item":"V_T8","infoItem":"V_T8","description":"_GQe","links":"NuyX"};